module.exports = function (root, children) {
  var props = children.split('.');
  var tracker = root[props.shift()];

  while (props.length) {
    if (tracker.hasOwnProperty(props[0])) {
      tracker = tracker[props.shift()];
    } else {
      return;
    }
  }
  return tracker;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/safe-object/index.js
// module id = 116
// module chunks = 0